import { Popover } from 'antd';
import KeyIcon from 'assets/Icons/KeyIcon';
import React, { ReactNode } from 'react';

import { interTight } from '@/components/Layout';

interface Props {
  children: ReactNode;
  title?: string;
  message?: string;
}

const ClaimTooltip: React.FC<Props> = ({ children, title, message }) => {
  return (
    <Popover
      styles={{
        body: {
          background: '#121212',
          padding: '16px',
          border: '1px solid #282829',
          borderRadius: '8px',
          maxWidth: '315px',
          ...interTight.style,
        },
      }}
      arrow={false}
      content={
        <div className='flex flex-col gap-2'>
          <div className='flex items-start gap-2'>
            <KeyIcon />
            <p className='text-sm leading-[22px] text-white font-semibold'>
              {title}
            </p>
          </div>
          <p className='text-grayZl-500 text-xs/5 font-normal'>{message}</p>
        </div>
      }
    >
      {children}
    </Popover>
  );
};

export default ClaimTooltip;
